import React from 'react';
import LegalPage from '../components/LegalPage';

const sections = [
    {
        title: 'Ce cookie-uri folosim',
        table: {
            head: ['Cookie-ul', 'Furnizorul', 'La ce folosește', 'Cât durează', 'Categoria'],
            rows: [
                ['evoo_consent (sau echivalentul platformei de consimțământ)', 'EVOO Medical', 'Ține minte alegerea dumneavoastră privind cookie-urile', '6 luni', 'strict necesar'],
                ['msal.* (cookie și memorie locală)', 'Microsoft', 'Autentificarea în contul de pacient', 'sesiunea', 'strict necesar'],
                ['_ga', 'Google Analytics', 'Deosebește vizitatorii, pentru statistici', '2 ani', 'analiză — numai cu acord'],
                ['_ga_<ID>', 'Google Analytics', 'Păstrează starea sesiunii, pentru statistici', '2 ani', 'analiză — numai cu acord']
            ]
        }
    },
    {
        title: 'Cum vă dați sau vă retrageți acordul',
        text: 'La prima vizită, fereastra de cookie-uri vă lasă să acceptați, să refuzați sau să alegeți pe categorii. Refuzul e la fel de ușor ca acceptul. Vă puteți schimba alegerea oricând, din legătura „Setări cookie-uri” din subsolul paginii, sau ștergând cookie-urile din browser.'
    },
    {
        title: 'Conținut de la terți',
        text: 'Harta locației și fonturile pot fi încărcate de la servicii Google. Când le încărcați, Google primește adresa IP a dispozitivului dumneavoastră.'
    },
    {
        title: 'Temeiul',
        unnumbered: true,
        text: 'Legea nr. 506/2004, art. 4 alin. (5); Regulamentul (UE) 2016/679. Versiunea în vigoare: 25.10.2026.'
    }
];

function PoliticaCookies() {
    return (
        <LegalPage
            eyebrow="Informații legale"
            title="Politica de cookie-uri"
            intro="Cookie-urile sunt fișiere mici pe care site-ul le pune în browserul dumneavoastră. Unele sunt necesare ca site-ul să funcționeze; celelalte le folosim numai dacă sunteți de acord."
            sections={sections}
            footnote="EVOO-COM-MAN-01-R3 · versiunea din 25.10.2026"
        />
    );
}

export default PoliticaCookies;
